import state from './modulePermissionState'
import actions from './modulePermissionActions'
import getters from './modulePermissionGetters'
import mutations from './modulePermissionMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}

